import React from 'react'
import { IconButton, IconButtonProps } from '@mui/material'
import { IconChevronLeft } from '@tabler/icons-react'

const BackIconButton: React.FC<IconButtonProps> = (props) => {
  return (
    <IconButton
      {...props}
      color="bordered"
      size="small"
      className="icon-btn-with-shadow"
    >
      <IconChevronLeft stroke={2} size={18} />
    </IconButton>
  )
}

export default BackIconButton
